import { useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../api";

import { Modal } from "react-bootstrap";

import "bootstrap/js/dist/modal.js";

import ModalComponentN4 from "../../components/Modal/ModalComponentN4";
import Loading from "../../components/Loading";
import IGVBrowser from "../../components/igv/IGVBrowser";

export default function SearchN4Table() {
    const params = useParams();
    const location = useLocation();
    const [N4Data, setN4Data] = useState([]);
    const [loading, setLoading] = useState(true);

    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    const fetchN4Records = useCallback(() => {
        let searchAdvanced = false;
        const formData = new FormData();

        if (location?.search) {
            searchAdvanced = true;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.forEach((v, k) => {
                formData.append(`filter[${k}]`, v);
            });
        }

        const urlParamsData = new URLSearchParams(formData);
        const sendParam = searchAdvanced ? urlParamsData : `filter[search]=${params?.name}`;

        api.get(`/search/n4?${sendParam}`)
            .then((response) => {
                const data = response.data;
                setN4Data(data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [params?.name, location]);

    useEffect(() => {
        if (params?.name) {
            fetchN4Records();
        }
    }, [params, fetchN4Records]);

    if (loading) return <Loading />;

    return (
        <div className="container">
            {/* <div className="my-5"></div> */}
            <div className="h5 mb-4">Search : {params?.name}</div>

            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>DNA Marker</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                Chromosome
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Position
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Favourable Allele
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Unfavourable Allele
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Target QTL
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Favourable Allele
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {N4Data.length > 0 ? (
                            N4Data.map((item) => {
                                return (
                                    <tr key={item?.id}>
                                        <th scope="row" className="font-monospace">
                                            {item?.chromosome}
                                        </th>
                                        <td className="font-monospace text-end">{item?.position}</td>
                                        <td className="font-monospace text-end">{item?.favourable_allele}</td>
                                        <td className="font-monospace text-end">{item?.unfavourable_allele}</td>
                                        <td className="font-monospace text-end">{item?.target_qtl}</td>
                                        <td className="font-monospace text-end">{item?.favourable_allele}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td className="text-center" colSpan={7}>
                                    ไม่พบข้อมูลที่Search
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="mt-4"></div>

            {N4Data.length > 0 && <IGVBrowser position={N4Data[0].position} chromosome={N4Data[0].chromosome} />}

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="font-monospace">
                        ID : {dataModal?.chromosome}
                        {dataModal && dataModal.position ? "-" + dataModal.position : null}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN4 data={dataModal} />
                </Modal.Body>
            </Modal>

            <br />
            <br />
            <br />
        </div>
    );
}
